type ListProps = {
  children: React.ReactNode;
  type: string;
};

const List = ({ children, type }: ListProps) => {
  const listMap = {
    bullet: <ul className='ml-8 list-disc'>{children}</ul>,
    number: <ol className='ml-8 list-decimal'>{children}</ol>,
  };

  return listMap[type as keyof typeof listMap];
};

export default List;
